import React from 'react';
import { Formik } from 'formik';

// Components
import { FormikSubmitRegistrar, StageSubmitRegistrar } from '../../_core/Formik/formik-submit-registrar.component';
import { RouteStageBuilder } from './route-stage-builder.component';
import { IRouteStageBuilderFormValues } from './route-stage-builder.interface';
import { IFormOption } from '../../_core/_ui/forms.component';
import _ from 'lodash';
import {
  buildRouteOptions,
  buildRouteNotificationOptions
} from '../assessment-stage.constants';
import { useCompanySportTerminology } from '../../../lib/stores/company.store';
import { IAssessmentStageBuilderBaseProps } from '../assessment-stage.types';

interface RouteStageBuilderContainerProps extends IAssessmentStageBuilderBaseProps {
  stage: IAssessmentStage;
  updateStage: Function;
  positionOptions: IFormOption[];
  // Catalog stage settings derive routes per band at apply time, so the route rows hide
  // and the key stays out of the submitted config.
  catalogSettingsMode?: boolean;
  registerStageSubmit?: StageSubmitRegistrar;
}

export const RouteStageBuilderContainer: React.FC<RouteStageBuilderContainerProps> = ({
  stage,
  updateStage,
  positionOptions,
  catalogSettingsMode,
  registerStageSubmit,
  style
}) => {
  const termLookup = useCompanySportTerminology()
  const routeNotificationOptions = buildRouteNotificationOptions(termLookup)
  const INITIAL_FORM_VALUES: IRouteStageBuilderFormValues = {
    routes: buildRouteOptions(stage.config.routes || [], positionOptions),
    notifications: _.find(routeNotificationOptions, option => option.value === stage.config.notifications) || routeNotificationOptions[0],
    enableNotifications: _.isBoolean(stage.config.enableNotifications) ? stage.config.enableNotifications : true,
    manualApproval: _.isBoolean(stage.config.manualApproval) ? stage.config.manualApproval : true,
  };

  async function handleSubmit(values: IRouteStageBuilderFormValues, { setSubmitting }: any) {
    setSubmitting(false);

    const config = {
      manualApproval: values.manualApproval,
      ...(!catalogSettingsMode && {
        routes: values.routes.map(route => ({
          ...route,
          position: route.position?.value,
          takeFrom: route.takeFrom?.value,
          sendType: route.sendType?.value
        })),
      }),
      notifications: values.notifications?.value,
      enableNotifications: values.enableNotifications
    }

    updateStage(stage._id, { config });
  }

  return (
    <Formik enableReinitialize initialValues={INITIAL_FORM_VALUES} onSubmit={handleSubmit}>
      {form => (
        <>
          <FormikSubmitRegistrar id={stage._id} register={registerStageSubmit} />
          <RouteStageBuilder
            form={form}
            stage={stage}
            positionOptions={positionOptions}
            catalogSettingsMode={catalogSettingsMode}
            style={style}
          />
        </>
      )}
    </Formik>
  );
};
